import { all, call, cancel, fork, take, spawn } from 'redux-saga/effects';

import ActionTypes from '../../constants/ActionTypes';
import coreServices from '../core/services';
import watchers from './watchers';

function* postLoginSaga() {
  yield take(ActionTypes.CORE_INITIALIZE);

  yield call(coreServices.updateCurrentUser, { lastLogin: new Date() });
}

export default function* loginSaga() {
  const watcherTasks = yield all(watchers.map((watcher) => fork(watcher)));

  yield take([ActionTypes.AUTHENTICATE__SUCCESS, ActionTypes.AUTHENTICATE_SSO__SUCCESS, ActionTypes.REGISTER__SUCCESS]);
  yield cancel(watcherTasks);
  const preLoginPath = JSON.parse(localStorage.getItem('pre_login_path'));
  if (preLoginPath) {
    localStorage.removeItem('pre_login_path');
    yield call(coreServices.goToPath, preLoginPath);
  } else {
    yield call(coreServices.goToRoot);
  }
  yield spawn(postLoginSaga);
}
